import PageHero from "@/components/common/PageHero";
import FinalCTA from "@/components/sections/FinalCTA";
import Reveal from "@/components/common/Reveal";

const items = [
  { title: "Lumen Watches — Storefront", img: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=900&q=80", tag: "Shopify Plus" },
  { title: "Aurora Audio — PDP", img: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=900&q=80", tag: "PDP CRO" },
  { title: "Stride Soles — Landing", img: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=900&q=80", tag: "Landing Page" },
  { title: "Verde Skin — Subscription", img: "https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=900&q=80", tag: "Subscription" },
  { title: "Kova Apparel — Lookbook", img: "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=900&q=80", tag: "Editorial" },
  { title: "North Coffee — Brewing Page", img: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=900&q=80", tag: "F&B" },
  { title: "Helix Tech — Product", img: "https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?auto=format&fit=crop&w=900&q=80", tag: "Tech" },
  { title: "Atlas Bags — Hero", img: "https://images.unsplash.com/photo-1547949003-9792a18a2601?auto=format&fit=crop&w=900&q=80", tag: "Accessories" },
];

export default function PortfolioPage() {
  return (
    <main data-testid="portfolio-page">
      <PageHero
        eyebrow="Portfolio"
        title={<>Selected work for <span className="text-gradient">global D2C brands.</span></>}
        subtitle="A curated showcase of Shopify storefronts, PDPs, and conversion-focused experiences crafted by Kavion."
      />
      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((it, i) => (
            <Reveal key={it.title} delay={i * 0.04}>
              <div data-testid={`portfolio-item-${i}`} className="group overflow-hidden rounded-3xl border border-white/5 bg-[#0A0A0C] hover:border-blue-500/30 transition">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={it.img} alt={it.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent" />
                  <span className="absolute top-4 left-4 text-xs glass-heavy px-3 py-1 rounded-full text-zinc-200">{it.tag}</span>
                </div>
                <div className="p-5">
                  <h3 className="font-display text-lg font-bold text-white">{it.title}</h3>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <FinalCTA />
    </main>
  );
}
